import React from 'react'
import { graphql, HeadProps } from 'gatsby'
import { Layout } from '../components/Layout'
import { Header } from '../containers/Header'
import { Footer } from '../containers/Footer'
import { CommonHead } from '../components/CommonHead'
import { GatsbySiteMetaData } from '../app-types'
import {
  SectionContentInstanceProResources,
  candlelightProResources,
} from '../sections/instances/SectionContentInstanceProResources'

interface PageQueryType {
  site: GatsbySiteMetaData
}

export const Head = ({ data, location }: HeadProps<PageQueryType>) => (
  <CommonHead
    title="We call it | Qwick"
    description="Training materials and shift details for your We call it event with Qwick."
    url={data.site.siteMetadata.siteUrl + location.pathname}
  />
)

const Page = () => (
  <Layout header={<Header />}>
    <SectionContentInstanceProResources {...candlelightProResources} />
    <Footer />
  </Layout>
)

export const query = graphql`
  query weCallItPageQuery {
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`

export default Page
